<template>
  <div style="background-color: #F9FBFD;">
    <div class="news_header">
      <div class="news_header_img">
        <img src="../../assets/banner-1.png" alt="">
      </div>
      <div class="news_header_title" id="news_header_title">
        <div class="news_header_box"
          :style="index == titIndex || Number(index) + 3 == titIndex  ? 'color: #1D2B3E;' : ''"
          v-for="(item,index) in titleList" :key="index" @click="handleSelect(index)">
          <span>{{item.name}}</span>
        </div>
        <div class="tab-activation-item" :style="{
        		left: (newleft + 338)+'px',
        	}"></div>
        <div class="news_header_title_board">
          <div style="font-size: 24px;color: #ffffff;margin-bottom: 7px;">NEWS</div>
          <div style="width: 48px;height: 3px;background-color: #ffffff;margin-bottom: 5px;"></div>
          <div style="font-size: 24px;color: #ffffff;">通知资讯</div>
        </div>
      </div>
      <div v-if="titIndex == 0">
        <div class="news_content">
          <div class="news_content-box" @click="bandnewscon(item)" v-for="(item, key) in queryInfolist1" :key="key">
            <div class="news_content-box-title">
              <div class="news_content-box-title-item-img">
                <div style="font-size: 60px;color: #1D2B3E;line-height: 60px;font-weight: 600;">{{item.inday}}</div>
                <div style="font-size: 19px;color: #8693A4;">{{item.innian}}</div>
              </div>
              <div class="news_content-box-title-item-box">
                <span>{{item.title}}</span>
                <div>
                  <span class="news_content-box-title-item-box-button">新闻资讯</span>
                </div>
                <span>{{item.brief}}</span>
              </div>
            </div>
            <div class="news_content-box-box">
              <img :src="item.resourceFile.resUrl" alt="">
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total1" :page-size="queryInfo1.pageSize"
              :current-page="queryInfo1.pageNum" @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="titIndex == 1">
        <div class="news_activity">
          <div class="news_activity_box" @click="bandactivity(item)" v-for="(item, key) in queryInfolist2" :key="key">
            <div class="news_activity_box_img">
              <el-image style="width: 498px; height: 205px;" :src="item.imageFile.resUrl" :fit="fit">
                <div slot="error" class="image-slot">
                  <img src="../../assets/noimg.png" alt="">
                </div>
              </el-image>
            </div>
            <div class="news_activity_box_title">{{item.title}}</div>
            <div class="news_activity_box_day">{{item.startTime}}至{{item.endTime}}</div>
            <div class="news_activity_box_card" v-if="item.status == 2">
              <img src="../../assets/c1.png" alt="">
            </div>
            <div class="news_activity_box_card" v-if="item.status == 3">
              <img src="../../assets/c2.png" alt="" srcset="">
            </div>
            <div class="news_activity_box_card" v-if="item.status == 4">
              <img src="../../assets/c3.png" alt="" srcset="">
            </div>
          </div>
        </div>
        <div class="news-footer">
          <el-pagination background layout="prev, pager, next" :total="total2" :page-size="queryInfo2.pageSize"
            :current-page="queryInfo2.pageNum" @size-change="handleSizeChange2" @current-change="handleCurrentChange2">
          </el-pagination>
        </div>
      </div>
      <div v-if="titIndex == 2">
        <div class="news_content">
          <div class="news_content-box" @click="bandnewscon1(item)" v-for="(item, key) in queryInfolist3" :key="key">
            <div class="news_content-box-title">
              <div class="news_content-box-title-item-img">
                <div style="margin-bottom: 3px;font-size: 60px;color: #1D2B3E;">{{item.inday}}</div>
                <div style="font-size: 19px;color: #8693A4;">{{item.innian}}</div>
              </div>
              <div class="news_content-box-title-item-box">
                <span>{{item.title}}</span>
                <div>
                  <span class="news_content-box-title-item-box-button">学术指导</span>
                </div>
                <span>{{item.brief}}</span>
              </div>
            </div>
            <div class="news_content-box-box">
              <img :src="item.resourceFile.resUrl" alt="">
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total3" :page-size="queryInfo3.pageSize"
              :current-page="queryInfo3.pageNum" @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="titIndex == 3">
        <div class="news_content">
          <div class="news_content_locator">
            <i class="iconfont icon-daohangdizhi"></i>
            <span style="font-size: 16px;color: #8693A4;margin-left: 10px;">当前位置:</span>
            <span style="font-size: 16px;color: #8693A4;margin-left: 24px;cursor: pointer;" @click="goindex">通知资讯</span>
            <span style="font-size: 16px;color: #8693A4;margin: 0 12px;"> > </span>
            <span style="font-size: 16px;color: #8693A4;cursor: pointer;" @click="handleSelect(0)">新闻资讯 </span>
            <span style="font-size: 16px;color: #8693A4;margin: 0 12px;"> > </span>
            <span style="font-size: 16px;color: #1D2B3E;">资讯详情</span>
          </div>
          <div class="news_content_box ql-snow ql-editor" id="editor">
            <span class="news_content_box_title">{{queryInfodetail.title}}</span>
            <div class="news_content_box_time">
              <!-- <span class="About-teacher-box-box-button">武汉</span> -->
              <span>{{queryInfodetail.updatedTime}}</span>
            </div>
            <span v-html="queryInfodetail.content"></span>
          </div>
        </div>

      </div>
      <div v-if="titIndex == 4">
        <div class="news_content">
          <div class="news_content_locator">
            <i class="iconfont icon-daohangdizhi"></i>
            <span style="font-size: 16px;color: #8693A4;margin-left: 10px;">当前位置:</span>
            <span style="font-size: 16px;color: #8693A4;cursor: pointer;margin-left: 24px;"
              @click="handleSelect(1)">活动通知 </span>
            <span style="font-size: 16px;color: #8693A4;margin: 0 12px;"> > </span>
            <span style="font-size: 16px;color: #1D2B3E;">活动详情</span>
          </div>
          <div class="news_content_box ql-snow ql-editor" id="editor">
            <span class="news_content_box_title">{{queryInfodetail1.title}}</span>
            <div class="news_content_box_time">
              <!-- <span class="About-teacher-box-box-button">武汉</span> -->
              <span>{{queryInfodetail1.updatedTime}}</span>
            </div>
            <span v-html="queryInfodetail1.content"></span>
          </div>
          <div style="width: 100%;display: flex;justify-content: center;background-color: #ffffff;padding: 20px 0;"
            v-if="queryInfodetail1.resourceFileList.length > 0">
            <div class="btns" @click="flieForget()">
              下载附件
            </div>
          </div>
        </div>

      </div>
      <div v-if="titIndex == 5">
        <div class="news_content">
          <div class="news_content_locator">
            <i class="iconfont icon-daohangdizhi"></i>
            <span style="font-size: 16px;color: #8693A4;margin-left: 10px;">当前位置:</span>
            <span style="font-size: 16px;color: #8693A4;cursor: pointer;margin-left: 24px;"
              @click="handleSelect(2)">学术指导 </span>
            <span style="font-size: 16px;color: #8693A4;margin: 0 12px;"> > </span>
            <span style="font-size: 16px;color: #1D2B3E;">指导详情</span>
          </div>
          <div class="news_content_box ql-snow ql-editor" id="editor">
            <span class="news_content_box_title">{{queryInfodetail.title}}</span>
            <div class="news_content_box_time">
              <!-- <span class="About-teacher-box-box-button">武汉</span> -->
              <span>{{queryInfodetail.updatedTime}}</span>
            </div>
            <span v-html="queryInfodetail.content"></span>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        fit: 'fill',
        placeid: 0,
        titleList: [{
            name: '新闻资讯',
            value: 0
          },
          {
            name: '活动通知',
            value: 1
          },
          {
            name: '学术指导',
            value: 2
          }

        ],
        titIndex: 0,
        newwidth: 0,
        newheight: 4,
        newleft: 0,
        queryInfo1: {
          pageNum: 1,
          pageSize: 10,
          type: 1,
          status: 2
        },
        total1: 0,
        queryInfolist1: [],
        queryInfodetail: {},
        queryInfodetail1: {
          resourceFileList: []
        },
        queryInfo2: {
          pageNum: 1,
          pageSize: 10,
          status: 0
        },
        total2: 0,
        queryInfolist2: [],
        queryInfo3: {
          pageNum: 1,
          pageSize: 10,
          type: 2,
          status: 2
        },
        total3: 0,
        queryInfolist3: [],

      }
    },


    watch: {
      titIndex(newVal) {
        this.titIndex = newVal
        this.$nextTick(() => {
          this.newinit()
        })
        if (this.titIndex == 0) {
          this.getofficialnewslist()
        } else if (this.titIndex == 1) {
          this.getofficialnoticelist()
        } else if (this.titIndex == 2) {
          this.getofficialnewslist1()
        } else if (this.titIndex == 3) {
          this.placeid = this.$route.query.placeid
          this.getofficialnewsdetail()
        } else if (this.titIndex == 4) {
          this.placeid = this.$route.query.placeid
          this.getofficialnoticedetail()
        } else if (this.titIndex == 5) {
          this.placeid = this.$route.query.placeid

          this.getofficialnewsdetail()
        }
      },

    },
    created() {
      this.titIndex = this.$route.query.place
    },
    methods: {
      flieForget() {
        var batchDownloadDataArray = []
        for (var M in this.queryInfodetail1.resourceFileList) {
          batchDownloadDataArray.push({
            url: this.queryInfodetail1.resourceFileList[M].resUrl,
            fileName: this.queryInfodetail1.resourceFileList[M].resFileName
          })
        }
        for (let i = 0; i < batchDownloadDataArray.length; i++) {
          this.downloadByUrl(batchDownloadDataArray[i].url, batchDownloadDataArray[i].fileName)
        }
      },
      downloadByUrl(url, fileName) {
        const urlStr = url.replace(/\\/g, "/");
        const xhr = new XMLHttpRequest();
        xhr.open("GET", urlStr, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          const url = window.URL.createObjectURL(xhr.response);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
        };
        xhr.send();
      },

      handleSizeChange1(newSize) {
        this.queryInfo1.pageSize = newSize
        this.getofficialnewslist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange1(newPage) {
        this.queryInfo1.pageNum = newPage
        this.getofficialnewslist()
      },
      handleSizeChange2(newSize) {
        this.queryInfo2.pageSize = newSize
        this.getofficialnoticelist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange2(newPage) {
        this.queryInfo2.pageNum = newPage
        this.getofficialnoticelist()
      },
      handleSizeChange3(newSize) {
        this.queryInfo3.pageSize = newSize
        this.getofficialnewslist1()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange3(newPage) {
        this.queryInfo3.pageNum = newPage
        this.getofficialnewslist1()
      },
      async getofficialnewslist() {

        let res = await this.$Http.officialnewslist(this.queryInfo1)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist1 = []
        for (let key in res.data.data.list) {

          res.data.data.list[key].inday = res.data.data.list[key].publishTime.slice(8, 10);
          let now = new Date(res.data.data.list[key].publishTime);
          res.data.data.list[key].inday = now.getDate();
          res.data.data.list[key].innian = now.getFullYear() + '-' + (now.getMonth() + 1)
          this.queryInfolist1.push(res.data.data.list[key])
        }
        this.total1 = res.data.data.total

      },
      async getofficialnewslist1() {

        let res = await this.$Http.officialnewslist(this.queryInfo3)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist3 = []
        for (let key in res.data.data.list) {

          res.data.data.list[key].inday = res.data.data.list[key].publishTime.slice(8, 10);
          let now = new Date(res.data.data.list[key].publishTime);
          res.data.data.list[key].inday = now.getDate();
          res.data.data.list[key].innian = now.getFullYear() + '-' + (now.getMonth() + 1)
          this.queryInfolist3.push(res.data.data.list[key])
        }
        this.total3 = res.data.data.total

      },
      async getofficialnoticelist() {

        let res = await this.$Http.officialnoticelist(this.queryInfo2)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist2 = res.data.data.list
        this.total2 = res.data.data.total

      },
      async getofficialnewsdetail() {

        let res = await this.$Http.officialnewsdetail({
          id: this.placeid
        })
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfodetail = res.data.data


      },
      async getofficialnoticedetail() {

        let res = await this.$Http.officialnoticedetail({
          id: this.placeid
        })
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfodetail1 = res.data.data
      },
      goindex() {
        this.$router.push({
          path: '/index'
        })
      },
      bandnewscon(item) {

        this.titIndex = 3
        this.$router.push({
          query: {
            place: this.titIndex,
            placeid: item.id
          }
        })
      },
      bandnewscon1(item) {

        this.titIndex = 5
        this.$router.push({
          query: {
            place: this.titIndex,
            placeid: item.id
          }
        })
      },
      handleSelect(index) {
        this.titIndex = index
        this.$router.push({
          query: {
            place: this.titIndex
          }
        })
      },
      newinit() {
        let data = document.getElementsByClassName('news_header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          let titIndexnum = 0
          if (Number(this.titIndex) > 2) {
            this.newwidth = arr[Number(this.titIndex) - 3]
            titIndexnum = Number(this.titIndex) - 3
          } else {
            this.newwidth = arr[this.titIndex]
            titIndexnum = this.titIndex
          }

          this.newleft = arr.slice(0, titIndexnum).reduce((num, item) => {
            return num + item + 70
          }, 0)
          document.getElementById('news_header_title').scrollLeft = this.newleft - arr[this.titIndex] / 2;
        }
      },
      bandactivity(item) {
        this.titIndex = 4
        this.$router.push({
          query: {
            place: this.titIndex,
            placeid: item.id
          }
        })
      }

    },
    mounted() {
      this.newinit()
    },
  }
</script>
<style lang="less" scoped>
  .w {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
  }

  .news_header {
    width: 100%;
    position: relative;
  }

  .news_header_img {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .news_header_title {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
    height: 85px;
    padding-left: 348px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    background-color: #ffffff;
  }

  .news_header_box {
    display: inline-block;
    color: #808080;
    font-size: 16px;
    cursor: pointer;
    margin-right: 70px;
    z-index: 99;
  }

  .tab-activation-item {
    background: #1D2B3E;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .news_header_title_board {
    position: absolute;
    left: 0;
    top: -84px;
    width: 269px;
    height: 169px;
    background-color: #1A7BFC;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 27px;
  }

  .news_content {
    width: 1200px !important;
    margin: 0 auto;
    margin-top: 40px;

  }

  .news_content-box {
    width: 100%;
    padding: 28px 20px;
    height: 174px;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    margin: 20px 0;
    cursor: pointer;
    align-items: center;
  }

  .news_content-box-title {
    width: 902px;
    overflow: hidden;
    display: flex;
  }

  .news_content-box-title-item-img {
    width: 137px;
    height: 118px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 20px;
    border-right: 1px solid #DEE3EB;
  }

  .news_content-box-title-item-box {
    width: 725px;
    height: 118px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 2px 54px;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // background-color: #1A7BFC;
  }

  .news_content-box-title-item-box span:nth-child(1) {
    font-size: 20px;
    color: #395172;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news_content-box-title-item-box span:nth-child(2) {
    font-size: 14px;
    color: #8693A4;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .news_content-box-title-item-box span:nth-child(3) {
    font-size: 14px;
    color: #8693A4;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .news_content-box-title-item-box-button {
    display: inline-block;
    padding: 2px 5px;
    background: rgba(134, 147, 164, 0.1);
    font-size: 12px !important;
    border-radius: 2px;
    color: #8693A4 !important;
  }

  .news_content-box-box {
    width: 277px;

    img {
      width: 100%;
    }
  }

  .news-footer {
    width: 100%;
    padding: 50px;
    box-sizing: border-box;
    text-align: center;
  }

  .news_content_locator {
    width: 100%;
    height: 54px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
  }

  .icon-daohangdizhi {
    color: #8693A4;
  }

  .news_content_box {
    margin-top: 24px;
    width: 100%;
    height: 100%;
    padding: 43px 53px;
    box-sizing: border-box;
    background-color: #ffffff;
  }

  .news_content_box_title {
    font-size: 48px;
    color: #395172;
    font-weight: 600;
  }

  .news_content_box_time {
    margin-top: 24px;
    margin-bottom: 52px;
    color: #8693A4;
    font-size: 20px;
  }

  .news_activity {
    width: 1200px !important;
    padding: 78px 36px 50px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
  }

  .news_activity_box {
    width: 546px;
    height: 341px;
    background-color: #ffffff;
    padding: 24px;
    box-sizing: border-box;
    float: left;
    position: relative;
    margin-bottom: 36px;
    margin-right: 36px;
    cursor: pointer;
  }

  .news_activity_box:nth-child(2n) {
    margin-right: 0 !important;
  }

  .news_activity_box_img {
    overflow: hidden;
    width: 100%;
    height: 205px;
    border-radius: 4px;


  }

  .news_activity_box_title {
    margin-top: 24px;
    font-size: 20px;
    color: #395172;
    width: 324px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news_activity_box_day {
    margin-top: 12px;
    font-size: 16px;
    color: #8693A4;
  }

  .news_activity_box_card {
    position: absolute;
    bottom: 40px;
    right: 0;
    width: 114px;
    height: 44px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
  }

  .news_activity_box_card img {
    width: 100%;
  }

  // .news_activity_box_card:before,
  // .news_activity_box_card:after {
  //   position: absolute;
  //   content: " ";
  //   top: -38px;
  //   left: -47px;
  //   display: block;
  //   width: 0;
  //   height: 0;
  //   border: 60px solid #F8F8F8;
  //   border-color: transparent transparent transparent #ffffff;
  //   z-index: 111;
  // }

  /deep/ .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 128px;
    }
  }

  .btns {
    display: inline-block;
    padding: 13px 39px;
    color: #FFFFFF;
    font-size: 14px;
    box-sizing: border-box;
    background: #1A7BFC;
    margin: 0 auto;
    cursor: pointer;
  }
</style>
